import { Box, Button, Paper, Tab, Tabs, Typography } from "@mui/material";
import React, { SetStateAction } from "react";
import { MapMode } from "../../../context/MapContext";
import { useMapMode, useUpdateMapMode } from "../../../utils/router";
import { AddressSearchBar } from "../../landing/AddressSearchBar";
import { SchoolSearchBar } from "../SchoolSearchBar";
import { MapSidebar } from "../sidebar/MapSidebar";

interface MobileControlsProps {
  openDrawer: boolean;
  setOpenDrawer: React.Dispatch<SetStateAction<boolean>>;
}

export const MobileControls: React.FC<MobileControlsProps> = ({
  openDrawer,
  setOpenDrawer,
}) => {
  const updateMode = useUpdateMapMode();
  const mode = useMapMode();
  return (
    <Paper
      sx={{
        position: "absolute",
        width: "100vw",
        maxHeight: "Calc(100svh - 96px)",
        zIndex: 10,
        top: 0,
        left: 0,
        columnGap: { xs: ".5rem", md: ".5rem" },
        display: { xs: "flex", md: "none" },
        px: "1rem",
        borderRadius: ".5rem",
        backdropFilter: "blur(4px)",
        backgroundColor: "#fffffff0",
      }}
    >
      <Box
        sx={{
          width: "100%",
          gap: 1,
          display: "flex",
          flexDirection: "column",
          pb: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            position: "sticky",
            top: 0,
            gap: 0.5,
          }}
        >
          <Tabs
            value={mode ?? "assignments"}
            onChange={(_, value) => updateMode(value as MapMode)}
            variant="fullWidth"
          >
            <Tab label="Assignments" value={"assignments"} />
            <Tab label="Systemwide" value={"view"} />
            {/* <Tab label="Edit" value={"edit"} /> */}
          </Tabs>
          {mode === "assignments" ? (
            <AddressSearchBar routeToMap={false} />
          ) : null}
          {mode === "view" ? <SchoolSearchBar /> : null}
        </Box>
        <Button variant="outlined" onClick={() => setOpenDrawer(!openDrawer)}>
          <Typography sx={{ fontSize: ".875rem" }}>
            {openDrawer ? "Hide details" : "Expand details"}
          </Typography>
        </Button>
        {openDrawer ? (
          <Box
            sx={{
              height: "100%",
              overflow: "hidden",
              overflowY: "auto",
              width: "100%",
            }}
          >
            <MapSidebar mobile={true} />
          </Box>
        ) : null}
      </Box>
    </Paper>
  );
};
